import { motion } from "framer-motion";
import { Check } from "lucide-react";

export function MomentShell({ icon: Icon, label, time, title, text, done, index, testid, children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.06 }}
      className={`rounded-2xl border p-5 transition-colors ${done ? "border-[#10B981]/40 bg-[#10B981]/5" : "border-[#27272A] bg-[#121215]"}`}
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <span className="inline-flex items-center gap-1.5 text-[12px] font-semibold uppercase tracking-wider" style={{ color: done ? "#10B981" : "#D4AF37" }}>
          <Icon size={13} /> {label} {done && <Check size={13} />}
        </span>
        {time && <span className="tabular-nums text-sm font-semibold text-[#8A8E96]">{time}</span>}
      </div>
      {title && <h3 className="a2g-read-title mt-2.5 text-xl font-semibold text-[#F4F4F5]">{title}</h3>}
      {text && <p className="a2g-read mt-2 text-base leading-relaxed text-[#B4B4BC]">{text}</p>}
      {children}
    </motion.div>
  );
}

export function SaveButton({ onClick, disabled, saving, label, testid }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || saving}
      data-testid={testid}
      className="btn-gold mt-5 w-full rounded-full px-5 py-3 text-sm font-semibold uppercase tracking-wide disabled:opacity-40"
    >
      {saving ? "…" : label}
    </button>
  );
}

export function EditLink({ onClick, testid, label = "Modifica" }) {
  return (
    <button type="button" onClick={onClick} data-testid={testid} className="mt-3 text-sm font-semibold text-[#D4AF37] underline-offset-4 hover:underline">
      {label}
    </button>
  );
}
